import { render } from "./UploadSheet.vue?vue&type=template&id=8904ff80"
import script from "./UploadSheet.vue?vue&type=script&lang=js"
export * from "./UploadSheet.vue?vue&type=script&lang=js"

import "./UploadSheet.vue?vue&type=style&index=0&id=8904ff80&lang=less"
script.render = render

export default script